import WarningIcon from '@mui/icons-material/Warning';
import styles from './FloraWarningBanner.module.css';

interface FloraWarningBannerProps {
	message?: string;
}

export const FloraWarningBanner = ({ message }: FloraWarningBannerProps) => (
	<div className={styles.banner} role="status" aria-live="polite">
		<WarningIcon className={styles.icon} aria-hidden="true" />
		<div className={styles.content}>
			<strong className={styles.title}>ATENÇÃO</strong>
			<p className={styles.message}>
				{message || 'Mensagem de warning do ocr.'}
			</p>
		</div>
	</div>
);
